import NextHead from 'next/head';
import { IChildrenProps } from '../../models/utilTypes';
export interface IMetaTagProps {
  name?: string;
  property?: string;
  content: string;
}

interface IHeadProps extends IChildrenProps {
  title: string;
  description?: string;
  canonical?: string;
  metaTags?: IMetaTagProps[];
}

const Head: React.FC<IHeadProps> = ({
  title = 'MaxPreps',
  description,
  canonical,
  children,
  metaTags = []
}) => (
  <>
    <NextHead>
      {canonical && <link rel="canonical" href={canonical} />}

      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {metaTags.map((metaTag, index) => (
        <meta key={index} {...metaTag} />
      ))}
      {/* Other items we want inside of the head */}
      {children}
    </NextHead>
  </>
);

export default Head;
